import Modal from "./Modal";
import withProvider from "../store/withProvider";

export default withProvider(Modal);
